import React, { useRef, useState, useEffect } from 'react';
import Tooltip from '../../../../components/Tooltip';

export default function SuggestedComponents({ components, onAdd, kept, plusOnly, onSuggestionMouseDown, setHoveredSuggestionPanel }) {
  const boxRefs = useRef([]);
  const [localComponents, setLocalComponents] = useState(components);
  useEffect(() => { setLocalComponents(components); }, [components]);

  useEffect(() => {
    if (boxRefs.current.length > 0) {
      // Heights calculation removed since it's unused
    }
  }, [localComponents]);

  function SuggestionBox({ title, description, isKept, i, comp }) {
    const [hover, setHover] = React.useState(false);
    useEffect(() => {
      // Reset on component unmount
    }, []);
    const handleClick = (e) => {
      if (onAdd) onAdd(comp);
      setLocalComponents(prev => prev.filter((c, idx) => idx !== i));
    };
    const box = (
      <div
        ref={el => boxRefs.current[i] = el}
        onMouseEnter={() => { setHover(true); }}
        onMouseLeave={() => { setHover(false); }}
        onMouseDown={handleClick} // Move add logic here
        onClick={e => e.preventDefault()} // Prevent double fire
        style={{
          background: hover ? 'rgba(187, 187, 187, 1)' : 'transparent',
          color: hover ? '#111' : '#222',
          borderRadius: 7,
          border: hover ? '1px solid transparent' : '1px dashed #fff',
          padding: 10,
          fontWeight: 500,
          fontSize: 14,
          boxShadow: '0 1px 4px #0001',
          textAlign: 'center',
          minWidth: 110,
          pointerEvents: 'auto',
          position: 'relative',
          cursor: 'pointer',
          transition: 'background 0.15s, color 0.15s, border 0.15s',
        }}
      >
        <div style={{ width: '100%', height: '100%' }}>
          <span style={{ fontWeight: 'bold', fontSize: 12, color: hover ? '#111' : '#fff', userSelect: 'none', display: 'block', textAlign: 'center', whiteSpace: 'nowrap' }}>{title}</span>
        </div>
      </div>
    );
    return description ? (
      <Tooltip text={description}>{box}</Tooltip>
    ) : (
      <span>{box}</span>
    );
  }

  if (!localComponents || localComponents.length === 0) return null;
  return (
    <div style={{
      display: 'flex',
      gap: 8,
      marginTop: 6,
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      paddingBottom: 20
    }}
    onMouseEnter={() => setHoveredSuggestionPanel && setHoveredSuggestionPanel(true)}
    onMouseLeave={() => setHoveredSuggestionPanel && setHoveredSuggestionPanel(false)}
    >
      {localComponents.map((comp, i) => {
        const isObj = typeof comp === 'object' && comp !== null && 'title' in comp && 'description' in comp;
        const title = isObj ? comp.title : String(comp);
        const description = isObj ? comp.description : '';
        const isKept = kept.some(k => (k.title || k) === title);
        return <SuggestionBox key={i} title={title} description={description} isKept={isKept} i={i} comp={comp} />;
      })}
    </div>
  );
}

